module.exports = __webpack_public_path__ + "media/images/nicklpass-icon-47510b3c98fd368b5d1fb0f7d4a43540.png";